import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73f8764b&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f8764b')) {
      api.createRecord('73f8764b', component.options)
    } else {
      api.reload('73f8764b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73f8764b&", function () {
      api.rerender('73f8764b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pdf/index.vue"
export default component.exports